import { render, staticRenderFns } from "./DocumentSignatureQrPanel.vue?vue&type=template&id=99ad5ddc&scoped=true"
import script from "./DocumentSignatureQrPanel.vue?vue&type=script&lang=js"
export * from "./DocumentSignatureQrPanel.vue?vue&type=script&lang=js"
import style0 from "./DocumentSignatureQrPanel.vue?vue&type=style&index=0&id=99ad5ddc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99ad5ddc",
  null
  
)

export default component.exports